module.exports = __webpack_public_path__ + "static/media/Landing Page.d45b4e1a.png";